type ZayaMarkProps = {
  className?: string;
  size?: "sm" | "md";
  variant?: "inline" | "stacked";
};

export function ZayaMark({
  className,
  size = "md",
  variant = "inline",
}: ZayaMarkProps) {
  const classes = [
    "zaya-mark",
    `zaya-mark--${size}`,
    `zaya-mark--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span aria-hidden="true" className={classes}>
      {variant === "stacked" ? (
        <>
          <span className="zaya-mark-line">ZA</span>
          <span className="zaya-mark-line">YA</span>
        </>
      ) : (
        "ZAYA"
      )}
    </span>
  );
}
